import { Button, Flex, Modal, type ModalProps, Text } from "@mantine/core";

const ShipsTimeInfoModal = ({ opened, onClose }: ModalProps) => (
  <Modal
    size="lg"
    yOffset={"25dvh"}
    opened={opened}
    onClose={onClose}
    title="Ship's Time Warning">
    <Flex direction="column" gap="lg" align="center">
      <Text>
        Please note you have changed the Ship's Time, please ensure all rows
        have been updated to reflect the change to the Ship's Time.
      </Text>
      <Button onClick={onClose}>OK</Button>
    </Flex>
  </Modal>
);

export default ShipsTimeInfoModal;
